import { colors } from '../theme/colors';

const status = {
  pending: { label: 'Pendentes', color: colors.color3 },
  completed: { label: 'Concluídas', color: colors.green1 },
  disqualified: { label: 'Desclassificados', color: colors.color5 },
};

function decoder(type) {
  return status[type] || {};
}

export { decoder as evaluationStatusDecoder };
